import { Mutation } from "@apollo/client/react/components";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Toasts } from "@selfdetermine/react-toasts";
import { ActionButton } from "../../../components";
import { ui } from "../../../Constants";
import { MutationSubmit } from "../../../Utils";

import { PERSON } from "../graphql";

import { INACTIVATE_ADDRESS } from "./graphql";

class InactivateAddressModalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  _toggleModal = () => {
    this.setState((prevState) => {
      const updated = !prevState.modal;

      return { modal: updated };
    });
  };

  render() {
    const { person, children } = this.props;

    return (
      <>
        <ActionButton
          onClick={this._toggleModal}
          className="table-btn"
          size="sm"
          color="secondary"
        >
          {children || <>{ui.icon.plus} New</>}
        </ActionButton>
        <Modal
          isOpen={this.state.modal}
          toggle={this._toggleModal}
          className={this.props.classNam}
          size="sm"
        >
          <ModalHeader toggle={this._toggleModal}>
            Inactivate Address
          </ModalHeader>
          <ModalBody>Are you sure you want to inactivate?</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this._toggleModal}>
              Cancel
            </Button>
            <Mutation
              mutation={INACTIVATE_ADDRESS}
              variables={{ person: person.id }}
              onCompleted={() => {
                Toasts.success("Address inactivated");
                this._toggleModal();
              }}
              onError={(error) =>
                Toasts.danger("Inable to inactivate address", error)
              }
              refetchQueries={[
                {
                  query: PERSON.ADDRESSES_QUERY,
                  variables: { person: person.id },
                },
              ]}
            >
              {(callMutation, { loading }) => (
                <MutationSubmit
                  color="danger"
                  label="Inactivate"
                  loadingLabel="Inactivating..."
                  onClick={callMutation}
                  loading={loading}
                />
              )}
            </Mutation>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

InactivateAddressModalForm.propTypes = {
  person: PropTypes.shape.isRequired,
};

InactivateAddressModalForm.defaultProps = {};

export default InactivateAddressModalForm;
